import { useAuthMutation } from './../auth'
import { ApiAgentRequest, request } from '../../utils'
import { StudentApplication } from '../../components/Application/types'

type SubmitApplicationProps = {
  id: string
}

type SubmitApplicationParams = undefined

type RawApplicationsResponse = {
  data: StudentApplication
}

export function useSubmitApplication(props: SubmitApplicationProps) {
  const { isPending, mutate } = useAuthMutation(async (params: SubmitApplicationParams) => {
    return await request<RawApplicationsResponse>(
      new ApiAgentRequest(`/applications/${props.id}/submit`, {
        method: 'POST',
      }),
      {
        isExpectedResponse: (res): res is RawApplicationsResponse => res as boolean,
      },
    )
  })

  return {
    isSubmittingApplication: isPending,
    submitApplication: mutate,
  }
}
